var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRewards(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1571 1.71094H3.84074C3.64901 1.71623 3.46122 1.76681 3.29253 1.85858C3.12384 1.95034 2.97902 2.08074 2.86974 2.2392L0.790671 5.13318C0.636291 5.35249 0.559191 5.61736 0.571608 5.88574C0.584026 6.15413 0.685248 6.41065 0.859212 6.61462L7.09643 13.838C7.20322 13.9764 7.34004 14.0883 7.49645 14.1653C7.65286 14.2424 7.82472 14.2824 7.99888 14.2824C8.17304 14.2824 8.34491 14.2424 8.50132 14.1653C8.65773 14.0883 8.79455 13.9764 8.90134 13.838L15.1385 6.61462C15.3125 6.41065 15.4137 6.15413 15.4262 5.88574C15.4385 5.61736 15.3615 5.35249 15.2071 5.13318L13.128 2.2392C13.0188 2.08074 12.874 1.95034 12.7053 1.85858C12.5366 1.76681 12.3487 1.71623 12.1571 1.71094Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.40576 1.71094L4.61719 6.05861L8.00004 14.2824",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.62857 1.71094L11.4057 6.05861L8 14.2824",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.59375 6.0625H15.4052",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewards);
export default __webpack_public_path__ + "static/media/rewards.c2133e8c04c413e59f9f833583a3800a.svg";
export { ForwardRef as ReactComponent };